module.exports = __webpack_public_path__ + "static/taley-5e6c69e33f92bceeee53540faad2ff80.jpg";